const LoadingSpinner = () => {
    return (
      <div className="flex justify-center py-2">
        <svg className="animate-spin size-8" viewBox="0 0 24 24">
          <defs>
            <linearGradient id="spinner-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#24ccf2" />
              <stop offset="100%" stopColor="#2476f2" />
            </linearGradient>
          </defs>
          <circle
            cx="12"
            cy="12"
            r="10"
            fill="none"
            strokeWidth="3"
            stroke="#e6f4ff"
          />
          <circle
            cx="12"
            cy="12"
            r="10"
            fill="none"
            strokeWidth="3"
            stroke="url(#spinner-gradient)"
            strokeLinecap="round"
            strokeDasharray="63"
            strokeDashoffset="16"
          />
        </svg>
      </div>
    );
  };
  
  export default LoadingSpinner;